export class ApiError extends Error {
  isApiError = true;
  constructor(msg: string, public errCode: string) {
    super(msg);
  }
}
